import { useMutation, useQuery, useQueryClient } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';

interface DeleteEntityParams {
  sourcePath: string[];
  destinationPath: string;
  clientId: string;
}

const moveObjects = async ({ sourcePath, destinationPath, clientId }: DeleteEntityParams) => {
  return authFetch(
    urlWithParams('/Consumer/DocumentVault/MoveObjects', {
      clientId,
      sourcePath,
      destinationPath,
    }),
    { method: 'POST' },
  );
};

export const useMoveObjectsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(moveObjects, {
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.listDocumentVaultEntities());
    },
  });
};
